// storeHelpers.js
import { watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

export function persistStore(store, key) {
  if (!key) {
    key = route.params.cartSlug
  }
  // Skip loading the store state from localStorage when the user is on the cart landing page
  const currentPath = window.location.pathname
  const skipLoadState = currentPath == `/cart/c/${key}/` || currentPath.includes('/step/0/')

  // Load the store state from localStorage when the app starts
  const storedState = localStorage.getItem(key)
  if (storedState && !skipLoadState) {
    store.$patch(JSON.parse(storedState))
  }

  // Watch the store and save changes to localStorage
  watch(
    () => store.$state,
    (newState) => {
      localStorage.setItem(key, JSON.stringify(newState))
    },
    { deep: true }
  )
}

export function removeLocalStorageItem(key) {
  if (localStorage.getItem(key) !== null) {
    localStorage.removeItem(key)
    console.log(`Item with key '${key}' was removed from localStorage.`)
  } else {
    console.log(`No item found in localStorage with key '${key}'.`)
  }
}

export async function processFeatureFlags(cartData) {
  if (cartData.cartConfig.signaturePage === 'V2') {
    cartData.cartSteps.forEach((step) => {
      step.formMetadata.forEach((metadata) => {
        // Filter out the signing_officer_signature field
        metadata.fields = metadata.fields.filter(
          (field) => field.name !== 'signing_officer_signature'
        )

        // Find and update the signing_officer field
        const signingOfficerField = metadata.fields.find(
          (field) => field.name === 'signing_officer'
        )
        if (signingOfficerField) {
          signingOfficerField.widget = 'RadioSelect'
          signingOfficerField.as = 'radio'
          signingOfficerField.type = 'radio'
        }
      })
    })
  }
  return cartData
}

// Helper function to scroll the window to the top
export function backToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}

export function resolveCartRoute(routeName, currentRoute) {
  const isPortalContext = currentRoute.name && currentRoute.name.startsWith('Portal');
  const prefix = isPortalContext ? 'Portal_' : '';
  return `${prefix}${routeName}`;
}